import { getCarouselData } from '../helpers/utils'
import { SHOW_CAROUSEL, HIDE_CAROUSEL } from '../actions/CarouselActions'


const initialState = {
  data: getCarouselData(),
  visible: false
}

function CarouselReducer(state=initialState, action){
  switch(action.type){

    case SHOW_CAROUSEL:
      return Object.assign({}, state, {visible:true})

    case HIDE_CAROUSEL:
      return Object.assign({}, state, {visible:false})

    default:
      return state
  }
}

export default CarouselReducer


// WEBPACK FOOTER //
// ./app/reducers/CarouselReducer.js